<template>
  <el-select
    :loading="loading"
    :model-value="list"
    filterable
    :placeholder="message"
    :clearable="!isMuch"
    :multiple="isMuch"
    :collapse-tags="isMuch"
    style="width: 100%"
    value-key="id"
    @change="changeValue"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item[name]"
      :value="value ? item[value] : item"
    />
  </el-select>
</template>
<script lang="ts" setup>
import { onMounted, getCurrentInstance, ref } from "vue";
import instance from "@/api/request";

const props = defineProps({
  list: {
    type: [String, Number, Array],
    default: "",
  },
  url: {
    type: String,
    default: "",
  },
  isMuch: {
    // 多选
    type: Boolean,
    default: false,
  },
  method: {
    // 切记不要大写
    type: String,
    default: "get",
  },
  param: {
    // 参数
    type: Object,
    default() {
      return {};
    },
  },
  message: {
    // 提示语
    type: String,
    default: "请选择",
  },
  dataOrigin: {
    // 例子：取data里的list ["data",'list']
    type: Array,
    default() {
      return ["data"];
    },
  },
  name: {
    type: String,
    default: "name",
  },
  value: {
    type: String,
    default: "id",
  },
  immediately: {
    // 是否立即请求
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits<{
  (e: "update:list", val: any): void;
  (e: "changeVal", val: any): void;
}>();

const app = getCurrentInstance()?.proxy;

onMounted(() => {
  if (props.url && props.immediately) {
    init();
  }
});

const loading = ref(false);
const options = ref();

const num = ref(0);
const targetData = (data: object): any => {
  if (num.value == props.dataOrigin.length) {
    return data;
  } else {
    ++num.value;
    const list = props.dataOrigin as string[];
    return targetData(data[list[num.value - 1]]);
  }
};

const init = () => {
  loading.value = true;
  instance[props.method](props.url, props.param).then((res: any) => {
    loading.value = false;
    if (res.code == 200) {
      num.value = 0;
      options.value = targetData(res);
    } else {
      app?.$message.error(res.message);
    }
  });
};

const changeValue = (val: any) => {
  console.log(val,'sidhj9asiud');
  
  emit("update:list", val);
  emit("changeVal", val);
};

defineExpose({
  init,
});
</script>
<style lang="scss" scoped></style>
